/**
 * EventBus class
 */
export class EventBus {
    /**
     * Constructor of class
     */
    constructor() {
        this.eventHandlers = {};
        // this.subscribers = {};
    }
    /**
     * Get Singleton instace of EventBus
     * @returns Instance of EventBus
     */
    static getInstance() {
        if (EventBus.instance === null || EventBus.instance === undefined) {
            if (window.EventBus == undefined || window.EventBus == null) {
                window.EventBus = new EventBus();
            }
            EventBus.instance = window.EventBus;
        }
        return EventBus.instance;
    }
    /**
     * Call all subscribers on the event
     * @param event Event to call subscribers
     * @param arg Arguments to send to the callback on subscriber
     * @returns Void
     */
    dispatch(event, arg) {
        const subscriber = EventBus.subscribers[event];
        if (subscriber === undefined) {
            return;
        }
        Object.keys(subscriber).forEach(key => subscriber[key](arg));
    }
    /**
     * Subscribe to events in the event-bus
     * @param event Event to subscribe
     * @param callback Method to call when event to subscribe is launch
     * @returns Object IResitry with unregister method
     */
    subscribe(event, callback) {
        const id = this.getNextId();
        if (!EventBus.subscribers[event])
            EventBus.subscribers[event] = {};
        EventBus.subscribers[event][id] = callback;
        return {
            unregister: () => {
                delete EventBus.subscribers[event][id];
                if (Object.keys(EventBus.subscribers[event]).length === 0)
                    delete EventBus.subscribers[event];
            }
        };
    }
    /**
     * Get Id for register subscriber
     * @returns number
     */
    getNextId() {
        return new Date().getTime() + EventBus.nextId++;
    }
    /**
     * Remove all subscribers for a given event.
     * Useful for cleanup when a component unmounts to prevent stale handlers.
     * @param event Event name whose subscribers should be removed
     */
    removeAllSubscribersForEvent(event) {
        delete EventBus.subscribers[event];
    }
    on(eventName, handler) {
        if (!this.eventHandlers[eventName]) {
            this.eventHandlers[eventName] = [];
        }
        this.eventHandlers[eventName].push(handler);
    }
    off(eventName, handler) {
        if (this.eventHandlers[eventName] !== null) {
            this.eventHandlers[eventName] = this.eventHandlers[eventName].filter((h) => h !== handler);
        }
    }
    emit(eventName, eventData) {
        const handlers = this.eventHandlers[eventName];
        if (handlers !== null && handlers != undefined) {
            handlers.forEach((handler) => handler(eventData));
        }
    }
}
EventBus.instance = null;
EventBus.subscribers = {};
EventBus.nextId = 0;
